// extracted by mini-css-extract-plugin
export default {"cardContainer":"style_cardContainer__wIDVu","cardContUp":"style_cardContUp__yfc3G"};